import React, { Component, useEffect, useContext } from 'react';
import {
  Link,
  withRouter
} from "react-router-dom";
import '../home/home-view.css';
import logo from "../../assets/logo.png";
import { SocketContext, initSocket } from "../../socket";
import { getActiveJob } from '../../reducers/calendar';
import { useDispatch } from '../../reducers/store';

class Header extends Component {
  state = {
    collapseID: '',
    modal1: false,
    isOpen: false,
    searchOpen: false
  };

  toggleCollapse = () => {
    this.setState({ isOpen: !this.state.isOpen });
  }

  toggleClose = () => {
    if (this.state.isOpen) {
      this.setState({ isOpen: false });
    }
  }

  toggleSearch = () => {
    this.setState({ searchOpen: !this.state.searchOpen });
  }

  closeSearch = () => {
    this.setState({ searchOpen: false });
    this.props.dispatchEnterSearch(undefined);
  }

  componentDidMount() {
    this.props.getRooms();


    //  initSocket(this.props.user._id);

    // this.props.getProfile();
  }

  logout = () => {
    this.props.logout();
  }

  handleMenuToggle = () => {
    if (window.matchMedia('(max-width: 768px)').matches) {
      document.body.classList.toggle('sidebar-open');
    } else {
      document.body.classList.toggle('sidebar-collapse');
    }
  }

  render() {

    const Socket = () => {
      const disp = useDispatch();

      // useContext(SocketContext);
      //  console.log(this.props.user)
      const socket = initSocket(this.props.user._id)
      const userId = this.props.user._id;
      //  console.log(socket);

      useEffect(() => {

        socket.on("yourRooms", (rooms) => {
          console.log('yourRooms', rooms);
          rooms.forEach(room => {
            //TODO send over all
            socket.emit("subscribe", room);
          });
        });

        socket.on("chat message", msg => {
          console.log('message', msg);
          this.props.receiveMessage(msg);
        });

        socket.on("updateActiveJobs", msg => {
          console.log('message', msg);
          disp(getActiveJob(msg.id));
        });

        socket.on("connect", () => {
          console.log('connect');
          socket.emit("identity", userId);
        });

        socket.on("disconnect", () => {
          console.log('disconnect');
        });

        return () => {
          // before the component is destroyed
          // unbind all event handlers used in this component
          socket.off("yourRooms");
          socket.off("chat message");
          socket.off("connect");
          socket.off("disconnect");
          socket.off("updateActiveJobs");
        };
      }, [socket, userId]);

      return (<></>);
    }

    // Breadcrumb: [Company] › [Current page] (design-system topbar pattern)
    const PAGE_NAMES = {
      '/dashboard': 'Dashboard', '/invoices': 'Invoices', '/expenses': 'Expenses',
      '/accounting': 'Accounting', '/clients': 'Clients', '/suppliers': 'Suppliers',
      '/calendar': 'Calendar', '/incidents': 'Incidents', '/recurring': 'Recurring',
      '/companies': 'Companies', '/company-settings': 'Company Settings',
      '/settings': 'Settings', '/statuses': 'Job Board',
      '/invoiceTemplates': 'Invoice Templates', '/statementTemplates': 'Statement Templates',
      '/templates': 'Document Templates', '/diagram': 'Appointment Settings',
    };
    const _path = ((this.props.location && this.props.location.pathname) || '').replace(/\/$/, '');
    let pageName = PAGE_NAMES[_path];
    if (!pageName) {
      if (_path.startsWith('/company/')) pageName = 'Company';
      else if (_path.startsWith('/invoiceTemplate/')) pageName = 'Invoice Template';
      else if (_path.startsWith('/statementTemplate/')) pageName = 'Statement Template';
      else if (_path.startsWith('/template/')) pageName = 'Template';
      else pageName = 'Dashboard';
    }
    const companyName = (this.props.company && this.props.company.companyName) || 'MoneyApp';

    return (
      <nav className="main-header" style={{
        background: 'rgba(255, 255, 255, 0.55)',
        WebkitBackdropFilter: 'blur(22px) saturate(1.4)',
        backdropFilter: 'blur(22px) saturate(1.4)',
        padding: '0 18px',
        height: 56,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'fixed',
        top: 14,
        right: 14,
        left: 242,
        zIndex: 1001,
        borderRadius: 16,
        border: '1px solid rgba(255, 255, 255, 0.65)',
        boxShadow: '0 10px 30px rgba(15, 31, 46, 0.10)',
      }}>
        <Socket />

        {/* Left side - Menu toggle */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <button
            onClick={this.handleMenuToggle}
            style={{
              background: 'rgba(15,31,46,0.06)',
              border: 'none',
              color: 'var(--text)',
              fontSize: 16,
              cursor: 'pointer',
              padding: '8px 11px',
              borderRadius: 10,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            title="Toggle menu"
          >
            <i className="fas fa-bars"></i>
          </button>

          {/* Breadcrumb — Company › Page › [sub-crumb] */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, fontFamily: 'var(--font-display)', color: 'var(--text-secondary)', minWidth: 0 }}>
            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 200 }}>{companyName}</span>
            <i className="fas fa-chevron-right" style={{ fontSize: 9, color: 'var(--text-muted)' }}></i>
            {this.props.crumb ? (
              <>
                <span style={{ whiteSpace: 'nowrap' }}>{pageName}</span>
                <i className="fas fa-chevron-right" style={{ fontSize: 9, color: 'var(--text-muted)' }}></i>
                <span style={{ color: 'var(--text)', fontWeight: 700, whiteSpace: 'nowrap' }}>{this.props.crumb}</span>
              </>
            ) : (
              <span style={{ color: 'var(--text)', fontWeight: 700, whiteSpace: 'nowrap' }}>{pageName}</span>
            )}
          </div>
        </div>

        {/* Right side - Search and User */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          {/* Search - only show on /statuses route */}
          {this.props.location && this.props.location.pathname === '/statuses' && (
            <div style={{ position: 'relative' }}>
              {!this.state.searchOpen && (
                <button
                  onClick={this.toggleSearch}
                  style={{
                    background: 'rgba(15,31,46,0.06)',
                    border: 'none',
                    color: 'var(--text-secondary)',
                    fontSize: 14,
                    cursor: 'pointer',
                    padding: '8px 12px',
                    borderRadius: 10,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    transition: 'all 0.2s ease'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(15,31,46,0.1)'}
                  onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(15,31,46,0.06)'}
                >
                  <i className="fas fa-search"></i>
                </button>
              )}

              {this.state.searchOpen && (
                <div style={{
                  position: 'absolute',
                  right: 0,
                  top: 0,
                  background: 'white',
                  borderRadius: 6,
                  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                  padding: 8,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 4,
                  minWidth: 280
                }}>
                  <input
                    onChange={(v) => this.props.dispatchEnterSearch(v.target.value)}
                    value={this.props.search || ''}
                    type="search"
                    placeholder="Search..."
                    autoFocus
                    style={{
                      flex: 1,
                      border: 'none',
                      outline: 'none',
                      padding: '8px 12px',
                      fontSize: 14,
                      borderRadius: 4
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'Escape') {
                        this.closeSearch();
                      }
                    }}
                  />
                  <button
                    onClick={this.closeSearch}
                    style={{
                      background: 'transparent',
                      border: 'none',
                      color: '#999',
                      cursor: 'pointer',
                      padding: '8px 10px',
                      borderRadius: 4,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      transition: 'all 0.2s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = '#f5f5f5';
                      e.currentTarget.style.color = '#333';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = 'transparent';
                      e.currentTarget.style.color = '#999';
                    }}
                  >
                    <i className="fas fa-times"></i>
                  </button>
                </div>
              )}
            </div>
          )}

          {/* User Dropdown */}
          <div className="dropdown dropleft">
            <button
              data-toggle="dropdown"
              style={{
                background: 'linear-gradient(135deg, var(--primary), var(--primary-dark))',
                border: 'none',
                color: 'white',
                width: 36,
                height: 36,
                borderRadius: '50%',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <i className="far fa-user"></i>
            </button>
            <div className="dropdown-menu dropdown-menu-right" style={{
              borderRadius: 8,
              boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
              border: '1px solid #eee',
              padding: 8,
              minWidth: 180,
              marginTop: 8
            }}>
              <Link to="/settings" className="dropdown-item" style={{
                padding: '10px 16px',
                borderRadius: 6,
                color: '#333',
                fontSize: 14
              }}>
                <i className="fas fa-cog" style={{ marginRight: 10, color: '#19a6b7' }}></i>
                Profile Settings
              </Link>
              <div style={{ height: 1, background: '#eee', margin: '8px 0' }}></div>
              <a onClick={() => this.logout()} className="dropdown-item" style={{
                padding: '10px 16px',
                borderRadius: 6,
                color: '#e84651',
                fontSize: 14,
                cursor: 'pointer'
              }}>
                <i className="fas fa-sign-out-alt" style={{ marginRight: 10 }}></i>
                Log out
              </a>
            </div>
          </div>
        </div>
      </nav>
    );
  }
};

const HeaderWithRouter = withRouter(Header);
export { HeaderWithRouter as Header };
